<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <label class="label-name">当前仓库：</label>
      <el-select size="small" class="organization-select" v-model="houseId" placeholder="请选择仓库">
        <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

    </div>

    <div class="list-title r" style="width:400px;padding-right:0;">
      <el-row>
        <el-col class="item-input">
          <label style="width:40px;text-align:left;">搜索：</label>
          <el-input style="margin-left:40px;width:auto;" v-model="filterKey" size="mini"
            placeholder="你可以搜索单号/工程/客户/退库名称">
          </el-input>
        </el-col>
      </el-row>
    </div>
    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="backType">
        <el-radio-button label="0">普通退库</el-radio-button>
        <el-radio-button label="1">业务性退库</el-radio-button>
      </el-radio-group>
    </div>
    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="number" v-if="backType == 0" label="退库单号" width="100" align="center">
      </el-table-column>
      <el-table-column prop="number" width="100" v-else label="业务性退库单号" align="center">
      </el-table-column>

      <el-table-column label="退库材料">
        <template slot-scope="scope">
          <span v-html="scope.row.outMaterials"></span>
        </template>
      </el-table-column>


      <el-table-column v-if="backType == 0" prop="projectName" label="工程">
      </el-table-column>
      <el-table-column v-if="backType == 0" prop="customer" label="客户">
      </el-table-column>
      <el-table-column v-if="backType == 1" label="退库名称" width="200px">
        <template slot-scope="scope">
          <span v-html="scope.row.name"></span>
        </template>
      </el-table-column>

      <el-table-column label="退库管理员" width="150">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="退库时间" width="140">
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="ShowMaterialBackDetail(scope.row)" type="primary">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination style="margin-left: -5px" v-if="form.pageTotal > form.pageSize" class="list-pagination" background
      :page-size="form.pageSize" :pager-count="9" :current-page="form.page + 1" layout="pager" :total="form.pageTotal"
      @current-change="handleCurrentChange">
    </el-pagination>

    <material-back-force-detail v-on:hideDetail="hideDetail()" :detailStatus="detailStatus"
      :materialBackForceData="materialBackData" :backType="backType">
    </material-back-force-detail>

  </div>
</template>

<script>
import {
  mapState
} from "vuex";

import UserInfo from '@/components/UserInfo'
import materialBackForceDetail from '@/page/storage/components/materialBackForceDetail'
export default {
  components: {
    UserInfo,
    materialBackForceDetail,
  },
  computed: {
    ...mapState({
      organization: state => state.main.organization,
      userData: state => state.main.userData,
      managerStorage: state => state.storage.managerStorage,
    })
  },
  data() {
    return {
      backType: 0,

      // 退库单明细详情
      detailStatus: false,
      materialBackData: "",

      houseId: "",
      depId: "",
      houseList: "",

      organizationListData: [],
      noSelectOrganization: true,
      // 列表
      loading: true,
      pageSize: 20,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],

      form: {
        houseId: '',
        page: 0,
        pageSize: 20,
        number: ""
      },

      // filter
      filterKey: "",
      filterTimeout: null,
    }
  },
  created() {
    if (this.$route.params.houseId) {
      this.form.houseId = this.houseId = this.$route.params.houseId / 1
    }
    this.depId = this.userData.secDepIds.split(",")[0] / 1
    // 获取仓库列表
    this.getHouseList()
  },
  mounted() {
    this.organizationListData = this.organization[0].childDepts
    this.depId = this.userData.secDepIds.split(",")[0] / 1

    if (this.userData.secDepIds.split(",")[0] == "7") {
      this.noSelectOrganization = false
    }
  },
  methods: {
    // 组装退库单材料
    getOutMaterials(row) {
      let _m = []
      for (var i = 0; i < row.materials.length; i++) {
        let _item = row.materials[i]
        _m.push(_item.name + '（' + _item.amount + _item.unitName + '）')
      }
      return _m.join(",")
    },

    // 显示退库单详情
    ShowMaterialBackDetail(row) {
      this.materialBackData = row
      this.detailStatus = true
    },
    // 隐藏详情
    hideDetail() {
      this.detailStatus = false
    },

    // 获取仓库列表
    getHouseList() {
      // 只能看到拥有权限的仓库
      this.houseList = this.managerStorage

      if (!this.houseId && this.houseList.length > 0) {
        this.houseId = this.houseList[0].id
      }

      this.getLists()
    },
    // 当前页
    handleCurrentChange(val) {
      this.form.page = val - 1;
      this.getLists();
    },
    // 搜索筛选新闻数据
    getFilterData() {
      this.form.page = 0;
      this.getLists();
    },
    // 分页筛选数据
    getPaginationData() {
      // 分页筛选
      this.paginationData = this.filterData;
    },
    // 获取列表
    getLists() {
      if (!this.houseId) {
        return
      }
      let _url = this.backType == 0 ? '/storage/material/back/list' : '/storage/material/back/force/list'
      this.form.number = this.filterKey;
      this.form.houseId = this.houseId;

      this.loading = true
      ajax.get(_url, this.form, (res) => {
        this.loading = false

        // 循环出所有退库材料至list
        let _list = res.vo.list
        for (let i = 0; i < _list.length; i++) {
          _list[i].outMaterials = this.getOutMaterials(_list[i])
        }

        this.filterData = this.listData = res.vo.list
        this.form.pageTotal = res.vo.size;
        this.getPaginationData()
      })
    },
  },
  watch: {
    "houseId"() {
      this.filterKey = ""
      this.getLists()
    },
    "backType"() {
      this.filterKey = ""
      this.getLists()
    },
    "filterKey"() {
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.getFilterData();
      }, 350)
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/page/storage/materialBackAllList.vue